import {Model} from "../Model";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {ProductAndItsCategory} from "./ProductAndItsCategory";
import Order from "./Order";
import BranchInfo from "./BranchInfo";
import Service from "./Service";

@usingJsonToModelConvertor
export class MenuOptionsAccess extends Model{

    @fromJsonObject({key: "ordering"})
    public ordering! :boolean;

    @fromJsonObject({key: "games"})
    public games! :boolean;

    @fromJsonObject({key: "services"})
    public services! :boolean;

    @fromJsonObject({key: "waiter_call"})
    public waiter_call! :boolean;

}

@usingJsonToModelConvertor
export class MenuDetails extends Model{

    @fromJsonObject({key: "menu_items", modelClass: ProductAndItsCategory, isArray: true})
    public menuItems! :ProductAndItsCategory[];

    @fromJsonObject({key: "active_order", modelClass: Order, isArray: false})
    public activeOrder! :Order;

    @fromJsonObject({key: "branch_info", modelClass: BranchInfo, isArray: false})
    public branchInfo! :BranchInfo;

    @fromJsonObject({key: "services", modelClass: Service, isArray: true})
    public services! :Service[];

    @fromJsonObject({key: "menu_options_access", modelClass: MenuOptionsAccess, isArray: false})
    public menuOptionsAccess! :MenuOptionsAccess;

    @fromJsonObject({key: "guest_token"})
    public guestToken! :string|null;

    @fromJsonObject({key: "table_number"})
    public tableNumber! :number;

    @fromJsonObject({key: "menu_color"})
    public menuColor! :string;

    @fromJsonObject({key: "theme_name"})
    public themeName! :string;

    @fromJsonObject({key: "user_is_guest_cant_order"})
    public userIsGuestCantOrder! :boolean;

}

